import { ComponentPropsWithoutRef } from "react";
import { Heading } from "~/components/elements/Heading";
import Grid from "~/components/globals/Grid";
import * as styles from "./SectionGridColumns.css";
import { Content } from "~/sanity/types";
import PortableText, {
  IPortableText,
} from "~/components/portableText/PortableText";
import { ILinkProps } from "~/components/elements/Link";
import { WrapperContentMask } from "~/components/wrappers/WrapperContentMask";

export type SectionGridColumnsProps = ComponentPropsWithoutRef<"div"> & {
  title?: string;
  subtitle?: string;
  text?: Content;
  link?: ILinkProps;
  hasBackgroundColor?: boolean;
  textLayout?: "default" | "fullWidth";
  layout?: "grid" | "fullWidth";
  columns?: 2 | 3;
};

export const SectionGridColumns = ({
  children,
  title,
  subtitle,
  text,
  hasBackgroundColor = false,
  layout = "grid",
  columns = 3,
}: SectionGridColumnsProps) => {
  const grid = (
    <Grid
      className={styles.gridWrapper({ hasBackgroundColor: hasBackgroundColor })}
    >
      {(subtitle || title || text) && (
        <div className={styles.headingWrapper}>
          <div
            className={styles.headerText({
              hasText: text || subtitle ? true : false,
            })}
          >
            {subtitle && (
              <Heading as="h2" size="h3" className={styles.subtitle}>
                {subtitle}
              </Heading>
            )}
            {title && (
              <Heading as="h3" size="h1" uppercase bold>
                {title}
              </Heading>
            )}

            {text && <PortableText blocks={text as IPortableText} />}
          </div>
        </div>
      )}
      <div className={styles.content({ layout: layout })}>
        <div className={styles.grid({ columns })}>{children}</div>
      </div>
    </Grid>
  );

  return (
    <section>
      {hasBackgroundColor ? (
        <WrapperContentMask
          className={styles.wrapper({ hasBackgroundColor: hasBackgroundColor })}
        >
          {grid}
        </WrapperContentMask>
      ) : (
        <div
          className={styles.wrapper({ hasBackgroundColor: hasBackgroundColor })}
        >
          {grid}
        </div>
      )}
    </section>
  );
};
